<template>
  <a-card :bordered='false' style='border-left:2px solid #3BA1EB;margin-left: -2px;'>
    <a-divider orientation='left' style='margin-top: -5px;'>
      门禁记录
    </a-divider>
    <a-table
      ref="table"
      bordered
      size="middle"
      rowKey="id"
      :columns="columns"
      :dataSource="dataSource"
      :pagination="false"
      :loading="loading"
      @change="handleTableChange">
    </a-table>
  </a-card>
</template>

<script>
import {getAction, postAction} from '@/api/manage'
import {FzisListMixin} from '@/mixins/FzisListMixin'

export default {
  components: {
  },
  mixins: [FzisListMixin],
  name: 'AccessInfo',
  data() {
    return {
      bidProjectId: '',
      disableMixinCreated: true,
      columns: [
        {
          title: '序号',
          dataIndex: '',
          key: 'rowIndex',
          width: 60,
          align: 'center',
          customRender: function(t, r, index) {
            return parseInt(index) + 1
          }
        },
        {
          title: '人员类型',
          align: "center",
          dataIndex: 'type_dictText'
        },
        {
          title: '人员名称',
          align: "center",
          dataIndex: 'personName'
        },
        {
          title: '进入时间',
          align: "center",
          dataIndex: 'accessTime'
        },
      ],
      url: {
        list: "/ebid-ce/tmGuardAccessInfo/list",
      },
    }
  },
  created() {

  },
  methods: {
    setBidProjectId(id, isRemoteEvaluation) {
      this.queryParam.bidProjectId = id;
      this.loadData();
    },
  }
}
</script>

<style lang='less' scoped>

</style>